import { useLocation } from "react-router-dom";

const SearchHeader = () => {
  const location = useLocation(); // Get current URL
  const params = new URLSearchParams(location.search);
  const listing_type = params.get("listing_type"); // e.g., 'foreclosure', 'fsbo'
  const category = params.get("category")
  const city = params.get("city")
  const county = params.get("county")
  const suburb = params.get("suburb")

  let headingText = "Search Results by "
  let spanText = "Filters"
  if (suburb) {
    headingText = "Search Results by Suburb";
    spanText = suburb

  }else if(county){
    headingText = "Search Results by County";
    spanText = county
    if(category){
      headingText = `Search Results for ${category}s by County`
    }

  } else if(city){
    headingText = "Search Results by City";
    spanText = city
    if(category){
      headingText = `Search Results for ${category}s by City`
      if(listing_type){
        headingText = `Search Results for ${category}s for ${listing_type} by City`
      }
    }
  }



  return <h6 className="mb-0">{headingText}(<span>{spanText}</span>)</h6>;
};

export default SearchHeader;
